import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import { chatResetMessage } from '../../../Actions/GroupChatMessageActions';
import { UnreadCountDelete } from '../../../Actions/UnreadCount';
import {
    RecentVideoCall,
    RecentAudioCall,
    RecentCallHangup,
    AudioOn,
    AudioOff,
    RecentDeletedMessage,
} from '../../../assets/images';
import { groupstatus } from '../../../Helpers/Chat/RecentChat';
import IndexedDb from '../../../Helpers/IndexedDb';
import {
    getFormatPhoneNumber,
    getFormattedRecentChatText,
    getHighlightedText,
    capitalizeFirstLetter,
    capitalizeTxt,
    sendNotification,
    getArchiveSetting,
    shouldHideNotification,
} from '../../../Helpers/Utility';
import { Store } from '../../../store';
import { getAvatarImage, groupAvatar } from '../../../Components/WebChat/Common/Avatarbase64';
import ProfileImage from '../../../Components/WebChat/Common/ProfileImage';
import { formatActivityTime } from '../../../Components/WebChat/WebChatTimeStamp';
import {
    formatGroupIdToJid,
    formatUserIdToJid,
    getContactNameFromRoster,
    getDataFromRoster,
    handleMentionedUser,
    initialNameHandle,
    isLocalUser,
} from '../../../Helpers/Chat/User';
import SDK from '../../../Components/SDK';
import { updateUnreadFlagRecentChat } from '../../../Actions/RecentChatActions';
import {
    CHAT_COUNT_DISPLAY_MAX,
    CHAT_TYPE_GROUP,
    GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
} from '../../../Helpers/Chat/Constant';
import { getDeletedMessageText } from '../../../Helpers/Chat/Recall';
import {
    notificationMessageType,
    isActiveConversationUserOrGroup,
    isTextMessage,
} from '../../../Helpers/Chat/ChatHelper';
import { isChatMuted } from '../../../Helpers/Chat/muteState';
import browserTab from '../../../Helpers/Browser/BrowserTab';
import Modal from '../../../Components/WebChat/Common/Modal';
import browserNotify from '../../../Helpers/Browser/BrowserNotify';
import { getFromLocalStorageAndDecrypt } from '../../../Components/WebChat/WebChatEncryptDecrypt';
import { isMatchingUserId } from '../../calls/utils/helper';
import { endCallKitCall, rejectCallKitCall, toggleCallKitAudio } from '../../calls/utils/sdkCallMethods';
import PollPreview from '../../poll/PollPreview';
import { isPollMessage, POLL_MESSAGE_TYPE } from '../../poll/pollRules';
import { CALLKIT_CALLSCREENSTATUS } from '../../calls/constants';
import recentChatIdb from '../../../Helpers/RecentChatIdb';
import { emojiUtils } from '../../../Helpers/EmojiUtils';
import { i18n } from '../../../localization/i18n';
import logger from '../../../Helpers/logger';
import { IconForwarded, IconMutedIndicator, IconPinIndicator } from '../../../Components/Common/Icons';
import { getPreviewIcon } from '../../../Components/WebChat/Common/messagePreviewIcon';
import RecentChatContextMenu from '../RecentChatContextMenu';
import Message from '../Message';
import {
    getAudioPreview,
    getCallPreview,
    getBatchCounts,
    getContactPreview,
    getDocumentPreview,
    getLocationPreview,
    getPhotoPreview,
    getReactionPreviewText,
    getReactionTargetText,
    getSystemEventPreview,
    getVideoPreview,
} from '../previewText';
import { isLiveLocationLabel } from '../../location/locationRules';
import { isForwardedMany } from '../../forwardMessage/forwardRules';
const HtmlToReactParser = require('html-to-react').Parser;
const htmlToReactParser = new HtmlToReactParser();

const LONG_PRESS_DELAY = 500;
// The chat list sizes and colours each preview glyph through its wrapper class.
const PREVIEW_ICON_CLASS = {
    image: 'chat-camera',
    video: 'chat-video',
    audio: 'mic chat-audio',
    file: 'chat-docu',
    contact: 'chat-contact',
    location: 'chat-location',
    call: 'chat-missedcall',
};

// The context menu and its dialogs render in a portal, so their clicks still
// bubble to the row but originate outside the chat list.
const isOutsideRow = event => !event.target?.closest?.('ul.chat-list-ul');
class RecentChatItem extends Component {
    constructor(props = {}) {
        super(props);
        this.state = {
            image: null,
            showModal: false,
            archiveChat: false,
            isArchive: true,
            needToImplement: false,
            PrevUnreadCount: 0,
            contextMenuOpen: false,
            contextMenuPosition: { x: 0, y: 0 },
        };
        this.localDb = new IndexedDb();
        this.audio = new Audio('sounds/busySignal.mp3');
        // Store previous comparable values per fromUserId to detect real changes
        this.prevComparableRef = {};
        this.longPressTimer = null;
        this.longPressFired = false;
    }
    getContactName = () => {
        const { item = {} } = this.props;
        return getContactNameFromRoster(item.roster);
    };

    handleToggleMute = () => {
        const { callkitData } = this.props;
        const localUser = (callkitData?.ongoingCallParticipants || []).find(p => isLocalUser(p.userId));
        toggleCallKitAudio(localUser?.isAudioMuted || false);
    };

    stopAudio() {
        this.audio.loop = false;
        this.audio.pause();
        this.audio.currentTime = 0;
    }

    handleToggleHangUpCall = () => {
        this.stopAudio();
        const { callkitData } = this.props;
        if (callkitData?.callScreenStatus === CALLKIT_CALLSCREENSTATUS.INCOMING) {
            rejectCallKitCall();
        } else {
            endCallKitCall();
        }
    };

    // Helper to escape raw HTML-like tags
    escapeHtmlIfNeeded(str) {
        if (typeof str === 'string') {
            return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        return str;
    }

    formatMessage = (msgBody, msgType, metaData = {}) => {
        let message = msgBody.message;
        const { item: { recent: { chatType } } = {} } = this.props;

        // Incoming call events arrive as msgType 'receiveMessage', so check the body too.
        const resolvedMsgType = msgBody?.message_type === 'call' || msgType === 'call' ? 'call' : msgType;

        // Suffix of the class tinting a call preview; empty for every other message type.
        let callTone = '';

        if (['image', 'video', 'audio', 'file', 'contact', 'location', 'meet', 'call'].indexOf(resolvedMsgType) > -1) {
            const isLive = isLiveLocationLabel(msgBody, metaData);
            const PreviewIcon = getPreviewIcon(resolvedMsgType, msgBody, metaData);

            if (msgBody && typeof msgBody === 'object') {
                if (resolvedMsgType === 'meet') {
                    message = msgBody?.meet?.link;
                } else if (resolvedMsgType === 'image') {
                    message = getPhotoPreview(msgBody.media);
                } else if (resolvedMsgType === 'video') {
                    message = getVideoPreview(msgBody.media);
                } else if (resolvedMsgType === 'audio') {
                    message = getAudioPreview(msgBody.media);
                } else if (resolvedMsgType === 'file') {
                    message = getDocumentPreview(msgBody.media);
                } else if (resolvedMsgType === 'contact') {
                    message = getContactPreview(msgBody.contact);
                } else if (resolvedMsgType === 'location') {
                    message = getLocationPreview(msgBody.location, isLive);
                } else if (resolvedMsgType === 'call') {
                    const callMeta = msgBody || {};
                    const currentUserId = this.props?.vCardData?.data?.userId;
                    const callStatus = callMeta.status || 'ended';
                    const isVideoCall = callMeta.callType === 'video';
                    const viewerIsCaller = isMatchingUserId(callMeta.caller || callMeta.initiator || '', currentUserId);
                    const inList = ids => (Array.isArray(ids) && currentUserId ? ids.includes(currentUserId) : false);
                    const { text, tone } = getCallPreview({
                        status: callStatus,
                        isVideo: isVideoCall,
                        viewerIsCaller,
                        viewerMissed: inList(callMeta.missedUserIds) || inList(callMeta.declinedUserIds),
                    });
                    message = text;
                    callTone = tone;
                } else {
                    message = capitalizeFirstLetter(msgType);
                }

                // The count labels the whole batch, so one file's caption must not replace it.
                const { imageCount, videoCount } = getBatchCounts(msgBody?.media);
                const isMediaBatch = imageCount + videoCount > 1;

                if (msgBody?.media?.caption && !isMediaBatch) {
                    try {
                        const tmp = document.createElement('div');
                        tmp.innerHTML = msgBody.media.caption;

                        const nodes = Array.from(tmp.childNodes || []);
                        const out = [];
                        let prevWasEmpty = false;

                        const isNodeEmpty = node => {
                            if (!node) return true;
                            if (node.nodeType === Node.TEXT_NODE) {
                                return (node.textContent || '').replace(/\u00A0/g, ' ').trim().length === 0;
                            }
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                // If element contains a mention span, treat as non-empty
                                if (node.querySelector && node.querySelector('span[data-mentioned]')) return false;
                                const inner = (node.innerHTML || '')
                                    .replace(/<br\s*\/?>/gi, '')
                                    .replace(/&nbsp;/g, '')
                                    .trim();
                                return inner.length === 0;
                            }
                            return true;
                        };

                        nodes.forEach(node => {
                            const empty = isNodeEmpty(node);
                            if (empty) {
                                prevWasEmpty = true;
                                return; // skip adding now
                            }
                            // if previous nodes were empty and we already have content, add a single line break
                            if (prevWasEmpty && out.length > 0) {
                                out.push(' ');
                            }
                            if (node.nodeType === Node.TEXT_NODE) {
                                out.push(node.textContent);
                            } else if (node.nodeType === Node.ELEMENT_NODE) {
                                const tag = (node.tagName || '').toLowerCase();
                                // For block-level wrappers (div, p), unwrap and keep inner HTML
                                if (tag === 'div' || tag === 'p') {
                                    out.push(node.innerHTML || '');
                                } else {
                                    out.push(node.outerHTML);
                                }
                            }
                            prevWasEmpty = false;
                        });

                        // join reconstructed parts; this removes leading/trailing empty blocks
                        message = out.join('');
                        // Convert mention spans to placeholder for downstream handling
                        const regex = /<span\s[^>]*>@([^<]+)<\/span>/g;
                        message = message.replace(regex, '@[?]');
                    } catch (e) {
                        message = msgBody.media.caption;
                    }
                }
            }

            message = htmlToReactParser.parse(
                handleMentionedUser({
                    text: getFormattedRecentChatText(message),
                    mentionedUsersIds: msgBody.mentionedUsersIds || [],
                    mentionedMe: false,
                    mentionedClass: '',
                    chatType,
                }),
            );

            return (
                <div
                    className={callTone ? `preview-media preview-call-${callTone}` : 'preview-media'}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {(message && PreviewIcon && (
                        <i className={PREVIEW_ICON_CLASS[resolvedMsgType]}>
                            <PreviewIcon />
                        </i>
                    )) ||
                        ''}{' '}
                    <p>{message}</p>
                </div>
            );
        }

        const safeText = this.escapeHtmlIfNeeded(getFormattedRecentChatText(message));

        const parsed = htmlToReactParser.parse(
            handleMentionedUser({
                text: safeText,
                mentionedUsersIds: msgBody.mentionedUsersIds || [],
                mentionedMe: false,
                mentionedClass: '',
                chatType: null,
            }),
        );

        return parsed;
    };

    getDeletedText = publisherId => (
        <span className="text-italic innerSpan">{getDeletedMessageText(isLocalUser(publisherId))}</span>
    );

    /**
     * handleLastMessage function is to handle the last message publisher name along with last message.
     */
    handleLastMessage = data => {
        const { vCardData: { data: { fromUser } = {} } = {} } = this.props;
        const {
            recent: { chatType, publisherId, msgBody, msgType, metaData },
        } = data;

        const conditionArray = [{ condition: 'groupchat' }, { condition: 'broadcast' }];
        const conditionCheck = conditionArray.some(ele => ele.condition === chatType);

        if (conditionCheck) {
            if (msgBody?.message_type === 'call' || msgType === 'call') {
                return this.formatMessage(msgBody, msgType);
            }

            // if (publisherId !== fromUser) {
            const senderDetails = getDataFromRoster(publisherId);

            if (senderDetails) {
                const lastMessageBy = publisherId === fromUser ? 'You' : getContactNameFromRoster(senderDetails);
                const lastMessage = this.formatMessage(msgBody, msgType, metaData);
                const hasMentionButtons = childrenArray => {
                    if (isString(childrenArray)) return true;
                    if (!Array.isArray(childrenArray)) return false;
                    return childrenArray.some(item => {
                        return React.isValidElement(item) && item.type === 'button';
                    });
                };

                return (
                    <Fragment>
                        {lastMessageBy && <span className="groupLastMessageBy">{lastMessageBy}: </span>}
                        {lastMessage && (
                            <span
                                className={`groupLastMessage ${
                                    lastMessage?.type === 'button' || hasMentionButtons(lastMessage) ? 'grouptag' : ''
                                }`}
                            >
                                {_get(this.props, 'item.recent.deleteStatus', 0) === 1 ? (
                                    <div className="deleted">
                                        <i className="recallMsgIcon">
                                            <RecentDeletedMessage />
                                        </i>
                                        <div className="deleted-message text-italic">
                                            {getDeletedMessageText(isLocalUser(publisherId))}
                                        </div>
                                    </div>
                                ) : (
                                    lastMessage
                                )}
                            </span>
                        )}
                    </Fragment>
                );
            }
            const unknownPublisher = senderDetails?.mobileNumber
                ? getFormatPhoneNumber(senderDetails.mobileNumber)
                : publisherId;
            return (
                <Fragment>
                    {unknownPublisher && <span className="groupLastMessageBy">{unknownPublisher}: </span>}
                    <span className="groupLastMessage">{this.formatMessage(msgBody, msgType, metaData)} </span>
                </Fragment>
            );
        }
        // }

        return _get(this.props, 'item.recent.deleteStatus', 0) === 1 ? (
            <>
                <i className="recallMsgIcon">
                    <RecentDeletedMessage />
                </i>
                {this.getDeletedText(publisherId)}
            </>
        ) : (
            this.formatMessage(msgBody, msgType, metaData)
        );
    };

    groupNotification = item => {
        const {
            rosterData: { data },
        } = this.props;
        const {
            recent: { publisherId, userId, profileUpdatedStatus, chatType, msgDisappear },
        } = item;

        const preview = getSystemEventPreview({
            status: profileUpdatedStatus,
            actorName: getContactNameFromRoster(getDataFromRoster(publisherId)) || getFormatPhoneNumber(publisherId),
            targetName: getContactNameFromRoster(getDataFromRoster(userId)) || getFormatPhoneNumber(userId),
            isActorMe: isLocalUser(publisherId),
            isTargetMe: isLocalUser(userId),
            groupName: this.getContactName(),
        });
        if (preview) return preview;

        // Description and disappearing-message events carry no FR59 wording of their own.
        return groupstatus(publisherId, userId, profileUpdatedStatus, data, chatType, msgDisappear);
    };

    /**
     * handleMessageType method to handle the last message type icon in recent chat section.
     * @param {object} item
     */
    handleMessageType = item => {
        const { recent = {} } = item;
        const { reactedUserName, emojiId, msgBody, msgType, deleteStatus, messageSenderId, chatType, publisherId } =
            recent;

        let updateLastReactionMessageStatus = false;

        if (chatType === 'groupchat') {
            updateLastReactionMessageStatus = deleteStatus !== 1 && reactedUserName && emojiId;
        } else {
            updateLastReactionMessageStatus = deleteStatus !== 1 && reactedUserName && emojiId;
        }

        // updateLastReactionMessageStatus = deleteStatus !== 1 && reactedUserName && emojiId && (this.props?.vCardData?.data?.userId === messageSenderId || this.props?.vCardData?.data?.userId === reactedUserName);
        // }

        let showReactionSummary = false;
        if (updateLastReactionMessageStatus) {
            const currentUserId = this.props?.vCardData?.data?.userId;
            if (chatType === 'chat') {
                // if (
                //     (messageSenderId ? messageSenderId : publisherId) === currentUserId ||
                //     reactedUserName === currentUserId
                // ) {
                showReactionSummary = true;
                // }
            } else if (chatType === 'groupchat') {
                if (
                    (messageSenderId ? messageSenderId : publisherId) === currentUserId ||
                    reactedUserName === currentUserId
                ) {
                    showReactionSummary = true;
                }
            }
        }

        if (showReactionSummary) {
            const reactorDetails = getDataFromRoster(reactedUserName);
            // Same wording as the desktop notification; React escapes the quoted text.
            const summary = getReactionPreviewText({
                isOwn: isLocalUser(reactedUserName),
                isGroup: chatType === 'groupchat',
                reactorName: reactorDetails ? getContactNameFromRoster(reactorDetails) : reactedUserName,
                emojiChar: emojiUtils.getEmojiById(emojiId)?.char || '',
                targetText: getReactionTargetText(msgType, msgBody),
            });
            return <span className="reaction-summary">{summary}</span>;
        } else {
            if (item.recent.msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY) {
                return this.groupNotification(item);
            }
            // Call events carry msgType 'receiveMessage', so the kind comes from the body.
            if (item.recent.msgBody?.message_type === 'call') {
                return this.handleLastMessage(item);
            }
            // The sentence names the actor itself, so no "{name}: " prefix is added.
            if (isPollMessage(item.recent) || item.recent.msgType === POLL_MESSAGE_TYPE) {
                return <PollPreview recent={item.recent} />;
            }
            switch (item.recent.msgType) {
                case 'text':
                case 'auto_text':
                case 'image':
                case 'video':
                case 'audio':
                case 'file':
                case 'contact':
                case 'location':
                case 'meet':
                case 'call':
                case 'channelInvitation':
                case 'story_reply':
                    return this.handleLastMessage(item);
                default:
                    return null;
            }
        }
    };

    addActiveClass = element => {
        const row = element.target?.closest?.('li');
        if (!row) return;
        row.closest('ul')?.querySelector('li.active')?.classList.remove('active');
        row.classList.add('active');
    };

    /**
     * clickListener() method to dispatch the action with contact info payload.
     * In this method, to perform display the conversation header section.
     * @param {object} event
     * @param {object} response
     */
    clickListener = (e, response) => {
        this.props.handlePopupState(true);
        const activeClass = e.target?.closest('li')?.classList?.contains('active');
        const recordingStatus = getFromLocalStorageAndDecrypt('recordingStatus');
        if (activeClass || recordingStatus === false) return;
        this.addActiveClass(e);
        let status = 'block';

        // When user switch chat clean it
        // Store.dispatch(clearChatSeenPendingMsg());
        Store.dispatch(chatResetMessage()).then(() => this.props.handleOnclick(status, response));
    };

    componentDidMount() {
        const { item: { roster: { image, groupImage } = {} } = {} } = this.props;
        this.setState({
            image: image || groupImage,
        });
    }

    componentDidUpdate(prevProps) {
        const {
            item: {
                recent,
                recent: { fromUserId, publisherId, chatType, muteStatus, archiveStatus = 0, editedStatus = 0 },
                roster: { image } = {},
            } = {},
            messageId,
            messageData,
            unreadCountData,
        } = this.props;
        const unreadData = unreadCountData?.unreadDataObj || {};

        const currentUnreadCount = unreadData?.[fromUserId]?.count ?? recent.unreadCount ?? 0;
        const prevUnreadCount =
            prevProps?.unreadCountData?.unreadDataObj?.[fromUserId]?.count ?? prevProps?.item?.recent?.unreadCount ?? 0;
        const currentComparable = {
            msgId: recent.msgId,
            timestamp: recent.timestamp,
            deleteStatus: recent.deleteStatus,
            editedStatus: recent.editedStatus,
            archiveStatus: recent.archiveStatus,
            muteStatus: recent.muteStatus,
            msgType: recent.msgType,
            createdAt: recent.createdAt,
            msgStatus: recent.msgStatus,
        };
        const prevComparable = this.prevComparableRef[fromUserId] || {};
        const hasRecentChanged = JSON.stringify(currentComparable) !== JSON.stringify(prevComparable);
        const hasUnreadCountChanged = currentUnreadCount !== prevUnreadCount;
        if (hasRecentChanged || hasUnreadCountChanged) {
            if (fromUserId && recent.muteStatus < 3) {
                recent.unreadCount = currentUnreadCount;
                recent.unreadMessageId = unreadData?.[fromUserId]?.unreadMsgId ?? recent.unreadMessageId ?? '';
                recentChatIdb.updateRecentChat(
                    fromUserId,
                    recent,
                    hasUnreadCountChanged ? 'unreadCountUpdate' : 'componentUpdate',
                );
            }

            this.prevComparableRef[fromUserId] = currentComparable;
        }

        const { data: { msgType, msgId, msgBody } = {} } = messageData || {};

        if (
            msgType &&
            msgType === 'carbonSentSeen' &&
            prevProps.messageData.id !== messageData.id &&
            msgId === messageId
        ) {
            Store.dispatch(UnreadCountDelete({ fromUserId }));
        }

        if (
            (this.props?.item?.recent?.msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY &&
                this.props?.item?.recent?.timestamp !== prevProps?.item?.recent?.timestamp) ||
            prevProps?.messageId !== messageId
        ) {
            const messageFromUser = this.props?.vCardData?.data?.fromUser;
            if (!isLocalUser(publisherId)) {
                const webSettings = getFromLocalStorageAndDecrypt('websettings');
                let parserLocalStorage = webSettings ? JSON.parse(webSettings) : {};
                const { Notifications = true } = parserLocalStorage;

                if (!isActiveConversationUserOrGroup(fromUserId, chatType) || !browserTab.isVisible()) {
                    const recentChat = this.props?.item;
                    const canNotify =
                        Notifications &&
                        !(muteStatus === 1 && isChatMuted(fromUserId)) &&
                        archiveStatus !== 1 &&
                        editedStatus !== 1;
                    if (msgType && typeof msgBody === 'string' && notificationMessageType.indexOf(msgBody) > -1) {
                        const {
                            recent: { NotificationTo },
                        } = recentChat;
                        if (NotificationTo !== messageFromUser && msgBody === '2') {
                            return;
                        }
                        canNotify && this.createPushNotification(recentChat);
                    } else {
                        const {
                            recent: { profileUpdatedStatus },
                        } = recentChat;
                        if (['userAdded'].includes(profileUpdatedStatus)) return;
                        canNotify && this.createPushNotification(recentChat);
                    }
                } else {
                    return;
                }
            } else {
                return;
            }
        }

        if (prevProps?.item?.roster?.image !== image) {
            this.setState({
                image: image,
            });
        }
    }

    getsenderName = contactDetails => {
        return getContactNameFromRoster(contactDetails);
    };

    createPushNotification = recentChat => {
        try {
            const {
                recent: {
                    chatType,
                    msgBody: { message_type, message, mentionedUsersIds },
                    publisherId,
                    fromUserId,
                },
                roster: { image, groupImage, thumbImage },
            } = recentChat;

            const isRawTag =
                isTextMessage(message_type) &&
                /^<[^>]+>$/.test(message) && // looks like <abc>
                !/@\[\?\]/.test(message); // does NOT contain a mention

            const messageBody = isTextMessage(message_type)
                ? handleMentionedUser({
                      text: message,
                      mentionedUsersIds: mentionedUsersIds,
                      mentionedMe: null,
                      mentionedClass: null,
                      chatType: 'notification',
                  })
                : capitalizeTxt(message_type || '');

            let updateMessage = message_type ? messageBody : this.handleMessageType(recentChat);

            let updateDisplayName, imageToken;

            if (chatType === 'chat') {
                updateDisplayName = this.getsenderName(recentChat.roster);
                imageToken = thumbImage && thumbImage !== '' ? thumbImage : image;
            } else {
                updateDisplayName = this.getContactName();
                imageToken = thumbImage && thumbImage !== '' ? thumbImage : groupImage;
                const senderName = getContactNameFromRoster(getDataFromRoster(publisherId)) || publisherId;
                if (message_type) updateMessage = `${senderName}: ${updateMessage}`;
            }

            const { unreadCountData } = this.props;
            const unreadDataObj = unreadCountData?.unreadDataObj || {};
            let totalChats = 0;
            let totalCounts = 0;
            Object.entries(unreadDataObj).forEach(item => {
                let count = item[1]?.count || 0;
                totalChats++;
                totalCounts = totalCounts + count;
            });
            if (shouldHideNotification() && browserNotify.isPageHidden && totalCounts > 0) {
                updateDisplayName = 'You have ' + totalChats + ' new chat' + (totalChats > 1 ? 's' : '');
                updateMessage = 'Total ' + totalCounts + ' unread message' + (totalCounts > 1 ? 's' : '');
            }
            this.localDb
                .getImageByKey(imageToken, 'profileimages')
                .then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    if (shouldHideNotification() && browserNotify.isPageHidden) {
                        blobUrl = '';
                    }
                    sendNotification(updateDisplayName, blobUrl, isRawTag ? message : updateMessage, fromUserId);
                })
                .catch(() => {
                    let avatarImage = chatType === 'chat' ? getAvatarImage : groupAvatar;
                    if (shouldHideNotification() && browserNotify.isPageHidden) {
                        avatarImage = '';
                    }
                    sendNotification(updateDisplayName, avatarImage, isRawTag ? message : updateMessage, fromUserId);
                });
        } catch (error) {
            logger.debug('[NOTIFICATION] createPushNotification failed', error);
        }
    };

    shouldComponentUpdate(nextProps) {
        const {
            unreadCountData: { id, activeUser },
            item: { recent: { msgfrom } = {} },
        } = this.props;
        return !(id && nextProps.unreadCountData.id !== id && msgfrom !== activeUser?.msgfrom);
    }

    componentWillUnmount() {
        this.clearLongPress();
    }

    openContextMenu = (x, y) => {
        this.setState({ contextMenuOpen: true, contextMenuPosition: { x, y } });
    };

    handleContextMenu = e => {
        e.preventDefault();
        this.openContextMenu(e.clientX, e.clientY);
    };

    handleLongPressStart = e => {
        // Right-click also raises pointerdown; that path is handled by onContextMenu.
        if (e.button !== 0) return;
        this.clearLongPress();
        const { clientX, clientY } = e;
        this.longPressTimer = setTimeout(() => {
            // Only a long press is followed by a click that must be swallowed.
            this.longPressFired = true;
            this.openContextMenu(clientX, clientY);
        }, LONG_PRESS_DELAY);
    };

    // Any movement means the user is scrolling the list, not holding a row.
    clearLongPress = () => {
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
            this.longPressTimer = null;
        }
    };

    handleContextMenuOpenChange = isOpen => {
        this.setState({ contextMenuOpen: isOpen });
    };

    // Opening a chat is what clears a manual "mark as unread"; keeping it would
    // leave the badge on a conversation the user just read.
    clearManualUnreadFlag = item => {
        const { fromUserId, chatType, unreadFlag } = item?.recent || {};
        if (unreadFlag !== 1 || !fromUserId) return;
        const jid = chatType === CHAT_TYPE_GROUP ? formatGroupIdToJid(fromUserId) : formatUserIdToJid(fromUserId);
        SDK.updateChatUnreadFlag(jid, false);
        Store.dispatch(updateUnreadFlagRecentChat({ fromUserId, isUnread: false }));
    };

    handleRecentChatClick = (e, item) => {
        if (item?.recent?.chatType === 'groupchat') {
            const groupData = this.props.groupsData?.data?.find(ele => ele.groupId === item?.roster?.groupId);
            if (groupData?.isAdminBlocked) {
                this.setState({ showModal: true });
                return;
            }
        }
        this.clearManualUnreadFlag(item);
        this.clickListener(e, item);
    };

    render() {
        const {
            item,
            item: { recent: { fromUserId } = {} } = {},
            searchTerm,
            vCardData,
            messageId,
            callUserJID,
            hidden,
            callStatus,
            enableDropDown = false,
            isAdminBlocked = false,
            callkitData,
        } = this.props;

        const {
            callScreenStatus: kitStatus,
            makeCallDetails,
            incomingCallDetails,
            groupId: callGroupId,
            callType: callTypeKit,
            callMode: callModeKit,
        } = callkitData || {};

        let kitActiveCallJid = '';
        if (kitStatus && kitStatus !== CALLKIT_CALLSCREENSTATUS.IDLE && kitStatus !== CALLKIT_CALLSCREENSTATUS.ENDED) {
            if (callModeKit === 'ONE-TO-MANY' || callModeKit === 'MEET') {
                kitActiveCallJid = callGroupId;
            } else {
                kitActiveCallJid =
                    makeCallDetails?.calleeId?.[0] || incomingCallDetails?.from || incomingCallDetails?.callerId;
            }
        }
        if (kitActiveCallJid && kitActiveCallJid.includes('@')) {
            kitActiveCallJid = kitActiveCallJid.split('@')[0];
        }

        const currentActiveCallJID = kitActiveCallJid || callUserJID;
        const isActiveCall = isMatchingUserId(fromUserId, currentActiveCallJID);
        const currentCallStatus = kitStatus || callStatus;

        const typeOfCall = (callTypeKit || this.props.callType || '').toLowerCase();

        // A live call is either ringing or connected, so it shares the call log's helper.
        const { text: ongoingCallDisplayText } = getCallPreview({
            status:
                currentCallStatus === CALLKIT_CALLSCREENSTATUS.INCOMING
                    ? CALLKIT_CALLSCREENSTATUS.INCOMING
                    : CALLKIT_CALLSCREENSTATUS.CONNECTED,
            isVideo: typeOfCall === 'video',
        });

        const localUser = (callkitData?.ongoingCallParticipants || []).find(p => isLocalUser(p.userId));
        const kitIsMuted = localUser?.isAudioMuted || false;

        const {
            item: { roster: { image, groupImage, thumbImage } = {} } = {},
            pageType = '',
            unreadCountData,
        } = this.props;
        const {
            roster: { groupId, emailId, userId },
            recent: {
                chatType,
                createdAt,
                msgStatus,
                msgType,
                deleteStatus,
                muteStatus,
                archiveStatus,
                pinStatus,
                favouriteStatus,
                unreadFlag,
                unreadCount: recentUnreadCount,
                seenReceipt,
                reactedUserName,
                emojiId,
            } = {},
        } = item;

        const lastMessage = this.handleMessageType(item);
        const messageDeliveryTime = (createdAt && formatActivityTime(createdAt)) || null;
        const contactName = this.getContactName();
        const iniTail = initialNameHandle(item.roster);
        const hightlightText = contactName ? getHighlightedText(contactName, searchTerm) : fromUserId;
        const token = getFromLocalStorageAndDecrypt('token');
        if (chatType === 'groupchat' && !groupId) return null;

        let selectedRoster = this.props.selectedRoster;
        let selectedJid = '';

        if (selectedRoster?.data?.roster) {
            selectedJid = selectedRoster.data.roster.userId;
            if (selectedJid === undefined) {
                selectedJid = selectedRoster.data.roster.groupId;
            }
        }
        const unreadDataObj = unreadCountData?.unreadDataObj || {};
        // Same precedence as componentDidUpdate: the live map wins, but fall back to the
        // count that arrived with the chat, otherwise a freshly loaded list shows no badge.
        let unreadCount = unreadDataObj[fromUserId]?.count ?? recentUnreadCount ?? 0;
        // A hand-marked chat has no real count behind it, so it reads as one unread message.
        const unreadBadgeCount = unreadCount > 0 ? unreadCount : unreadFlag === 1 ? 1 : 0;
        const isMutedNow = muteStatus === 1 && isChatMuted(fromUserId);

        const activeClass = userId || groupId;
        const { contextMenuOpen, contextMenuPosition, showModal } = this.state;
        const isPermanentArchvie = getArchiveSetting();
        let imageToken = '';
        if (!isAdminBlocked) {
            imageToken = thumbImage && thumbImage !== '' ? thumbImage : image || groupImage;
        }

        return (
            <Fragment>
                <li
                    style={{ display: hidden ? 'none' : '' }}
                    className={`chat-list-li ${pageType ? 'recentLiCustom' : ''} ${activeClass === selectedJid ? 'active' : ''} ${contextMenuOpen ? 'set-top' : ''} ${isActiveCall ? 'activeCall' : ''} ${unreadBadgeCount > 0 ? 'unread' : ''}`}
                    id="chat-list-id"
                    data-name="list"
                    data-chat-id={fromUserId}
                    tabIndex="0"
                    role="button"
                    onClick={e => {
                        // A long press already opened the menu; the click that ends it
                        // must not also open the conversation.
                        if (this.longPressFired) {
                            this.longPressFired = false;
                            return;
                        }
                        if (isOutsideRow(e)) return;
                        this.handleRecentChatClick(e, item);
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            if (isOutsideRow(e)) return;
                            this.handleRecentChatClick(e, item);
                        }
                    }}
                    onContextMenu={this.handleContextMenu}
                    onPointerDown={this.handleLongPressStart}
                    onPointerUp={this.clearLongPress}
                    onPointerCancel={this.clearLongPress}
                    onPointerMove={this.clearLongPress}
                >
                    <ProfileImage
                        chatType={chatType}
                        userToken={token}
                        userId={userId || groupId}
                        temporary={false}
                        imageToken={imageToken}
                        emailId={emailId}
                        name={iniTail}
                    />
                    <div className="recentchats">
                        <div className="recent-username-block">
                            <div className="recent-username">
                                <div className="username">
                                    <h3 title={contactName}>{hightlightText}</h3>
                                </div>
                            </div>
                            {lastMessage && (
                                <span
                                    className={
                                        unreadCount && parseInt(unreadCount) !== 0 ? 'messagetime-plus' : 'messagetime'
                                    }
                                >
                                    {messageDeliveryTime}
                                </span>
                            )}
                            {enableDropDown && fromUserId !== callUserJID && (
                                <RecentChatContextMenu
                                    open={contextMenuOpen}
                                    onOpenChange={this.handleContextMenuOpenChange}
                                    position={contextMenuPosition}
                                    chatId={fromUserId}
                                    chatType={chatType}
                                    archiveStatus={archiveStatus}
                                    muteStatus={muteStatus}
                                    pinStatus={pinStatus}
                                    favouriteStatus={favouriteStatus}
                                    unreadFlag={unreadFlag}
                                />
                            )}
                        </div>
                        <div className="recent-message-block">
                            {isActiveCall && (
                                <>
                                    <div
                                        className="iconOnGoingCall"
                                        onClick={this.props.handleShowCallScreen}
                                        tabIndex="0"
                                        role="button"
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                this.props.handleShowCallScreen();
                                            }
                                        }}
                                    >
                                        {typeOfCall === 'audio' ? (
                                            <i className="iconAudioCall">
                                                <RecentAudioCall />
                                            </i>
                                        ) : (
                                            <i className="iconvideoCall">
                                                <RecentVideoCall />
                                            </i>
                                        )}
                                    </div>
                                    <span
                                        className="callDetails preview-media preview-call-answered"
                                        onClick={this.props.handleShowCallScreen}
                                        onKeyDown={e => e.key === 'Enter' && this.props.handleShowCallScreen}
                                        tabIndex="0"
                                        role="button"
                                    >
                                        {ongoingCallDisplayText}
                                    </span>
                                </>
                            )}
                            {/* A live call replaces the preview: the row shows one line, not both. */}
                            {!isActiveCall && (
                                <Message
                                    msgStatus={msgStatus}
                                    lastMessage={lastMessage}
                                    messageId={messageId}
                                    fromUserId={fromUserId}
                                    chatUserType={chatType}
                                    msgType={msgType}
                                    publisherId={item.recent.publisherId}
                                    fromUser={vCardData?.data?.fromUser}
                                    deleteStatus={deleteStatus}
                                    seenReceipt={seenReceipt}
                                    reactedUserName={reactedUserName}
                                    emojiId={emojiId}
                                />
                            )}
                            <div className="recent-message-icon">
                                {((isMutedNow && pageType === 'recent') ||
                                    (isMutedNow && pageType === 'archive' && !isPermanentArchvie)) && (
                                    <i className="MuteChat" title={i18n.t('chat.menu.MUTE_CHAT')}>
                                        <IconMutedIndicator />
                                    </i>
                                )}
                                {pinStatus === 1 && (
                                    <i className="PinChat" title="Pinned">
                                        <IconPinIndicator />
                                    </i>
                                )}
                                {unreadBadgeCount > 0 && (
                                    <p className={`notifi${isMutedNow ? ' muted' : ''}`}>
                                        {unreadBadgeCount > CHAT_COUNT_DISPLAY_MAX
                                            ? `${CHAT_COUNT_DISPLAY_MAX}+`
                                            : unreadBadgeCount}
                                    </p>
                                )}
                                {archiveStatus === 1 && searchTerm && <span className="recent-badge">Archived</span>}
                            </div>
                        </div>
                        {isForwardedMany(item.recent?.metaData) && (
                            <div className="recent-warn-tags">
                                <span className="warn-tag forwarded" title={i18n.t('chat.preview.FORWARD_MANY_TIMES')}>
                                    <IconForwarded />
                                    {i18n.t('chat.preview.FORWARD_MANY_TIMES')}
                                </span>
                            </div>
                        )}
                    </div>
                    {isActiveCall && (
                        <div className="CallAction">
                            {currentCallStatus && currentCallStatus.toLowerCase() === 'connected' && (
                                <i
                                    onClick={this.handleToggleMute}
                                    title="Mute/Unmute"
                                    className={kitIsMuted ? 'Mute' : ''}
                                    onKeyDown={e => e.key === 'Enter' && this.handleToggleMute}
                                    tabIndex="0"
                                    role="button"
                                >
                                    {kitIsMuted ? <AudioOff /> : <AudioOn />}
                                </i>
                            )}
                            <i
                                title="Hangup"
                                className="Hangup"
                                onClick={this.handleToggleHangUpCall}
                                onKeyDown={e => e.key === 'Enter' && this.handleToggleHangUpCall}
                                tabIndex="0"
                                role="button"
                            >
                                <RecentCallHangup />
                            </i>
                        </div>
                    )}
                </li>
                {showModal && (
                    <Modal containerId="container">
                        <div className="popup-wrapper BlockedPopUp">
                            <div className="popup-container">
                                <div className="popup-container-inner" style={{ maxWidth: '23em' }}>
                                    <div className="popup-label">
                                        <label>{'This group is no longer available'}</label>
                                    </div>
                                    <div className="popup-noteinfo">
                                        <button
                                            onClick={() => this.setState({ showModal: false })}
                                            type="button"
                                            name="btn-action"
                                            className="popup btn-action danger"
                                        >
                                            {'OK'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        vCardData: state.vCardData,
        rosterData: state.rosterData,
        blockedContact: state.blockedContact,
        unreadCountData: state.unreadCountData,
        selectedRoster: state.activeChatData,
        contactsWhoBlockedMe: state.contactsWhoBlockedMe,
        groupsData: state.groupsData,
        callLogData: state.callLogData,
        UnreadUserObjData: state.UnreadUserObjData,
        callkitData: state.callkitData,
    };
};
export default connect(mapStateToProps, null)(RecentChatItem);

RecentChatItem.propTypes = {
    messageId: PropTypes.string,
    callUserJID: PropTypes.string,
    callStatus: PropTypes.string,
    callType: PropTypes.string,
    callMode: PropTypes.string,
    handleOnclick: PropTypes.func,
    handleShowCallScreen: PropTypes.func,
    messageData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    searchTerm: PropTypes.string,
    pageType: PropTypes.string,
    refreshUnreadCount: PropTypes.bool,
    handlePopupState: PropTypes.func,
    selectedRoster: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    callLogData: PropTypes.object,
    vCardData: PropTypes.object,
    item: PropTypes.object,
    unreadCountData: PropTypes.object,
    groupsData: PropTypes.object,
    hidden: PropTypes.bool,
    enableDropDown: PropTypes.bool,
    isAdminBlocked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    rosterData: PropTypes.object,
};
